import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Amplify kütüphanesini ve konfigürasyonumuzu import ediyoruz
import { Amplify } from 'aws-amplify';
import { awsconfig } from './config';

// Amplify'ı konfigürasyonumuzla yapılandırıyoruz
Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
